import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  ref: "container",
  class: "mb-10 py-1 px-4 text-left relative"
}
const _hoisted_2 = { class: "text-xl font-bold flex-grow text-left" }
const _hoisted_3 = {
  key: 0,
  class: "material-icons text-2xl"
}
const _hoisted_4 = {
  key: 1,
  class: "material-icons text-2xl"
}
const _hoisted_5 = ["id"]
const _hoisted_6 = { class: "text-charico p-2 mb-2 border-t-2 border-b-2 border-charico flex" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "flex-grow-0 mr-2 flex-shrink-0" }, "Q ：", -1)
const _hoisted_8 = { class: "flex-grow" }
const _hoisted_9 = { class: "p-2 text-disabled flex" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "flex-grow-0 mr-2 flex-shrink-0" }, "A ：", -1)
const _hoisted_11 = {
  key: 0,
  class: "flex-grow"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["href"]
const _hoisted_15 = { class: "underline" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, " open_in_new ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "flex items-center text-disabled p-4 mb-4 font-bold",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
    }, [
      _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.category.name), 1),
      (_ctx.open)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, " expand_less "))
        : (_openBlock(), _createElementBlock("span", _hoisted_4, " expand_more "))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass('mt-4 p-4' + (_ctx.open ? '' : ' hidden'))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.category.faq, (faq) => {
        return (_openBlock(), _createElementBlock("div", {
          key: faq.question,
          class: "mb-4",
          id: faq.key,
          ref_for: true,
          ref: _ctx.setQuestions
        }, [
          _createElementVNode("h3", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("span", _hoisted_8, _toDisplayString(faq.question), 1)
          ]),
          _createElementVNode("p", _hoisted_9, [
            _hoisted_10,
            (typeof faq.answer == 'string')
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(faq.answer), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(faq.answer, (data) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: typeof data == 'string' ? data : data.text
                    }, [
                      (typeof data == 'string')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(data), 1))
                        : (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: data.href,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            class: "text-link mb-1 decoration-link text-sm inline-flex items-center"
                          }, [
                            _createElementVNode("span", _hoisted_15, _toDisplayString(data.text), 1),
                            _hoisted_16
                          ], 8, _hoisted_14))
                    ]))
                  }), 128))
                ]))
          ])
        ], 8, _hoisted_5))
      }), 128))
    ], 2)
  ], 512))
}